export const FETCH_ORDERS = 'ORDERS/FETCH_ORDERS';
export const FETCH_ORDERS_SUCCESS = 'ORDERS/FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_ERROR = 'ORDERS/FETCH_ORDERS_ERROR';
export const APPROVE_ORDER = 'ORDERS/APPROVE_ORDER';
export const APPROVE_ORDER_SUCCESS = 'ORDERS/APPROVE_ORDER_SUCCESS';
export const APPROVE_ORDER_ERROR = 'ORDERS/APPROVE_ORDER_ERROR';
export const REJECT_ORDER = 'ORDERS/REJECT_ORDER';
export const REJECT_ORDER_SUCCESS = 'ORDERS/REJECT_ORDER_SUCCESS';
export const REJECT_ORDER_ERROR = 'ORDERS/REJECT_ORDER_ERROR';
export const EXPORT_EXCEL = 'ORDERS/EXPORT_EXCEL';
export const EXPORT_EXCEL_SUCCESS = 'ORDERS/EXPORT_EXCEL_SUCCESS';
export const EXPORT_EXCEL_ERROR = 'ORDERS/EXPORT_EXCEL_ERROR';
export const EXPORT_ORDER = 'ORDERS/EXPORT_ORDER';
export const EXPORT_ORDER_SUCCESS = 'ORDERS/EXPORT_ORDER_SUCCESS';
export const EXPORT_ORDER_ERROR = 'ORDERS/EXPORT_ORDER_ERROR';
export const CHECK_SC_TICKET = 'ORDERS/CHECK_SC_TICKET';
export const CHECK_SC_TICKET_SUCCESS = 'ORDERS/CHECK_SC_TICKET_SUCCESS';
export const CHECK_SC_TICKET_ERROR = 'ORDERS/CHECK_SC_TICKET_ERROR';
export const CREATE_SC_TICKET = 'ORDERS/CREATE_SC_TICKET';
export const CREATE_SC_TICKET_SUCCESS = 'ORDERS/CREATE_SC_TICKET_SUCCESS';
export const CREATE_SC_TICKET_ERROR = 'ORDERS/CREATE_SC_TICKET_ERROR';
export const SAVE_SHIPPING = 'ORDERS/SAVE_SHIPPING';
export const SAVE_SHIPPING_SUCCESS = 'ORDERS/SAVE_SHIPPING_SUCCESS';
export const SAVE_SHIPPING_ERROR = 'ORDERS/SAVE_SHIPPING_ERROR';
export const REORDER_PRODUCT = 'ORDERS/REORDER_PRODUCT';
export const REORDER_PRODUCT_SUCCESS = 'ORDERS/REORDER_PRODUCT_SUCCESS';
export const REORDER_PRODUCT_ERROR = 'ORDERS/REORDER_PRODUCT_ERROR';
export const SAVE_PACKING_SLIP = 'ORDERS/SAVE_PACKING_SLIP';
export const SAVE_PACKING_SLIP_SUCCESS = 'ORDERS/SAVE_PACKING_SLIP_SUCCESS';
export const SAVE_PACKING_SLIP_ERROR = 'ORDERS/SAVE_PACKING_SLIP_ERROR';
export const PRINT_PACKING_SLIP = 'ORDERS/PRINT_PACKING_SLIP';
export const PRINT_PACKING_SLIP_SUCCESS = 'ORDERS/PRINT_PACKING_SLIP_SUCCESS';
export const PRINT_PACKING_SLIP_ERROR = 'ORDERS/PRINT_PACKING_SLIP_ERROR';
export const FETCH_PACKING_SLIP_DATA = 'ORDERS/FETCH_PACKING_SLIP_DATA';
export const FETCH_PACKING_SLIP_DATA_SUCCESS = 'ORDERS/FETCH_PACKING_SLIP_DATA_SUCCESS';
export const FETCH_PACKING_SLIP_DATA_ERROR = 'ORDERS/FETCH_PACKING_SLIP_DATA_ERROR';
export const GENERATE_PRINT_READY_FILE = 'ORDERS/GENERATE_PRINT_READY_FILE';
export const GENERATE_PRINT_READY_FILE_SUCCESS = 'ORDERS/GENERATE_PRINT_READY_FILE_SUCCESS';
export const GENERATE_PRINT_READY_FILE_ERROR = 'ORDERS/GENERATE_PRINT_READY_FILE_ERROR';
export const SET_ID_MODAL = 'ORDERS/SET_ID_MODAL';
export const SET_TYPE = 'ORDERS/SET_TYPE';
export const SET_IS_FROM_EMAIL = 'ORDERS/SET_IS_FROM_EMAIL';
export const SET_ACTIVE_PAGE = 'ORDERS/SET_ACTIVE_PAGE';
export const RESET_STATE = 'ORDERS/RESET_STATE';
export const SET_SORT = 'ORDERS/SET_SORT';
export const SET_SEARCH = 'ORDERS/SET_SEARCH';
export const SET_SEARCH_TYPE = 'ORDERS/SET_SEARCH_TYPE';
export const SET_TRACKING_NUMBER = 'ORDERS/SET_TRACKING_NUMBER';
export const SET_SHIPPED = 'ORDERS/SET_SHIPPED';
export const SET_SHIPPING_METHOD = 'ORDERS/SET_SHIPPING_METHOD';
export const SET_SHIPPING_QUANTITY = 'ORDERS/SET_SHIPPING_QUANTITY';
export const SET_SHIPPING_WEIGHT = 'ORDERS/SET_SHIPPING_WEIGHT';
export const SET_SHIPPING_NUM_PACKAGES = 'ORDERS/SET_SHIPPING_NUM_PACKAGES';
export const SET_PACKING_SLIP_MESSAGE = 'ORDERS/SET_PACKING_SLIP_MESSAGE';
export const CHECK_PACKING_SLIP_ITEM = 'ORDERS/CHECK_PACKING_SLIP_ITEM';
export const SET_PACKING_SLIP_ITEMS = 'ORDERS/SET_PACKING_SLIP_ITEMS';
export const CHECK_SC_TICKET_CHECKBOX = 'ORDERS/CHECK_SC_TICKET_CHECKBOX';